module.exports = __webpack_public_path__ + "media/2.c92bc66a.mp3";